import { useEffect, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Translate } from "../../../Enums/Tranlate";
import SocialMediaService from "../../../../services/SocialMediaService";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { daysValuesOptions } from "../../../Enums/Fixed";
import Select from "react-select";

const SocialMedia = () => {
	const [formData, setFormData] = useState({
		location: "",
	});
	const [links, setLinks] = useState({});
	const [loading, setLoading] = useState(false);
	const [loadingData, setLoadingData] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const socialMediaService = new SocialMediaService();
	const SocialMediaLinks = [
		{ label: "Instagram", value: "instagram", type: "text" },
		{ label: "Snapchat", value: "snapchat", type: "text" },
		{ label: "Facebook", value: "facebook", type: "text" },
		{ label: "Linked In", value: "linked_in", type: "text" },
		{ label: "Call Us", value: "call_us", type: "number" },
		{ label: "Twitter", value: "twitter", type: "text" },
		{ label: "Phone", value: "phone", type: "number" },
		{ label: "Location", value: "location", type: "text" },
		{ label: "Email", value: "email", type: "email" },
		{ label: "Tiktok", value: "tiktok", type: "text" },
		{ label: "Support", value: "support_email", type: "email" },
		// { label: "Sales", value: "sales_email", type: "email" },
	];

	useEffect(() => {
		setLoadingData(true);
		socialMediaService?.getList()?.then((res) => {
			let response = res?.data?.data;
			if (res?.status === 200) {
				setLinks({ ...response });
			} else {
				let values = {};
				SocialMediaLinks?.map((link) => (values[link.value] = ""));
				setLinks({ ...values });
			}
			setFormData({
				day_from:
					daysValuesOptions?.find((day) => day?.value === response?.day_from) ||
					"",
				day_to:
					daysValuesOptions?.find((day) => day?.value === response?.day_to) ||
					"",
				time_from: response?.time_from || "",
				time_to: response?.time_to || "",
			});
		});
		setLoadingData(false);
	}, []);

	const inputHandler = (e) => {
		setLinks({ ...links, [e.target.name]: e.target.value });
	};
	console.log(links);
	const onSubmit = (e) => {
		e.preventDefault();

		let data = {};
		data["location"] = links.location || "";
		data["facebook"] = links.facebook || "";
		data["instagram"] = links.instagram || "";
		data["snapchat"] = links.snapchat || "";
		data["tiktok"] = links.tiktok || "";
		data["twitter"] = links.twitter || "";
		// data["whatsapp"] = links.whatsapp;
		// data["telegram"] = links.telegram;
		data["linked_in"] = links.linked_in || "";
		// data["play_store"] = links.play_store;
		// data["app_store"] = links.app_store;
		data["email"] = links.email || "";
		data["phone"] = links.phone || "";
		data["support_email"] = links.support_email || "";
		// data["sales_email"] = links.sales_email;
		data["call_us"] = links.call_us || "";
		data["day_from"] = formData.day_from?.value || "";
		data["day_to"] = formData.day_to?.value || "";
		data["time_from"] = formData.time_from || "";
		data["time_to"] = formData.time_to || "";

		setLoading(true);
		socialMediaService
			?.create(data)
			?.then((res) => {
				if (res.status === 201) {
					toast?.success("Added Social Links Successfully");
				}
				setLoading(false);
			})
			.catch((error) => {
				toast.error(error);
				setLoading(false);
			});
	};

	return (
		<>
			<Card>
				<Card.Body className="position-relative">
					<AvForm onValidSubmit={onSubmit}>
						<Row className="mb-3">
							{SocialMediaLinks?.map((link, index) => {
								return (
									<Col md={6} key={index}>
										<label className="text-label">
											{Translate[lang][link.value]} :
										</label>
										<AvField
											type={link.type}
											name={link.value}
											className="form-control"
											placeholder={`${Translate[lang][link.value]}`}
											value={links[link?.value]}
											onChange={(e) => inputHandler(e)}
										/>
									</Col>
								);
							})}
							<Col md={3}>
								<label className="text-label">
									{Translate[lang]?.day_from}
								</label>
								<Select
									value={formData?.day_from}
									options={daysValuesOptions}
									onChange={(e) =>
										setFormData({
											...formData,
											day_from: e,
										})
									}
								/>
							</Col>
							<Col md={3}>
								<label className="text-label">{Translate[lang]?.day_to}</label>
								<Select
									value={formData?.day_to}
									options={daysValuesOptions}
									onChange={(e) =>
										setFormData({
											...formData,
											day_to: e,
										})
									}
								/>
							</Col>
							<Col md={3}>
								<label className="text-label">
									{Translate[lang]?.time_from}
								</label>
								<AvField
									type="time"
									placeholder={Translate[lang]?.time_from}
									bsSize="lg"
									name="time_from"
									value={formData.time_from}
									onChange={(e) =>
										setFormData({
											...formData,
											time_from: e.target.value,
										})
									}
								/>
							</Col>
							<Col md={3}>
								<label className="text-label">{Translate[lang]?.time_to}</label>
								<AvField
									type="time"
									placeholder={Translate[lang]?.time_to}
									bsSize="lg"
									name="time_to"
									value={formData.time_to}
									onChange={(e) =>
										setFormData({
											...formData,
											time_to: e.target.value,
										})
									}
								/>
							</Col>
						</Row>
						<div className="d-flex justify-content-end">
							<Button
								variant="primary"
								type="submit"
								disabled={loading || loadingData}>
								{Translate[lang].submit}
							</Button>
						</div>
					</AvForm>
				</Card.Body>
			</Card>
		</>
	);
};
export default SocialMedia;
